import { ComposeControl, SubjectPickerViewState } from 'owa-mail-compose-store';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';

export default function createSubjectPickerViewState(options: {
    supportsSubjectPicker: boolean;
    isPickerOpened?: boolean;
    isLoadingConversation?: boolean;
    showBackButton?: boolean;
    showSubjectPickerButton?: boolean;
    isBackButtonHovered?: boolean;
    initialToRecipient?: ReadWriteRecipientViewState | null;
    nextFocusControl?: ComposeControl | null;
    initialContent?: string | null;
    wasSubjectSelected?: boolean;
}): SubjectPickerViewState {
    return {
        supportsSubjectPicker: options.supportsSubjectPicker,
        isPickerOpened: options.isPickerOpened,
        isLoadingConversation: options.isLoadingConversation,
        showBackButton: options.showBackButton,
        showSubjectPickerButton: options.showSubjectPickerButton,
        isBackButtonHovered: options.isBackButtonHovered,
        initialToRecipient: options.initialToRecipient,
        nextFocusControl: options.nextFocusControl,
        initialContent: options.initialContent,
        wasSubjectSelected: options.wasSubjectSelected,
    };
}
